 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-033c7ecc":"ca209e53","chunk-0bc784a4":"8fd1067d","chunk-0c4f239d":"45a36ca1","chunk-1179b6b8":"aa4485e8","chunk-12bf4dfb":"b3cd3b21","chunk-15438fe4":"309955cf","chunk-170c2e37":"ec5bac51","chunk-1d0ed6ee":"eeef010a","chunk-1d2fdd37":"efe14f30","chunk-1e6a62ff":"98439df1","chunk-1e6b03db":"c14cb803","chunk-1e6b05c0":"73368427","chunk-1e6b3357":"97cf7342","chunk-1e6b97da":"ac315995","chunk-1e6c0d5f":"62bce462","chunk-1e7f3edf":"72c01c85","chunk-1e7fb51d":"6dda8e61","chunk-1e802e52":"324e6439","chunk-1e8034ec":"1b2b6c59","chunk-1e806324":"d7f7eaa4","chunk-218898d8":"ce7a0f9c","chunk-52da3b00":"10412290","chunk-1e68f8bd":"d17bb03b","chunk-1e6a5f32":"8bcbf950","chunk-1e8017f1":"5bd47d14","chunk-5966f576":"9448148f","chunk-b172f240":"44ba8bdc","chunk-316ae1f0":"c2294f85","chunk-62cba3dc":"c1f6e08d","chunk-245cf861":"a8d3e314","chunk-2d0ac931":"cc71baa3","chunk-2d0bd20a":"d79cba49","chunk-2d0c211b":"20162011","chunk-2d0c5583":"878b56ca","chunk-2d0c8234":"ac20c33b","chunk-2d0cf315":"e659bcff","chunk-2d0cfa15":"68b05007","chunk-2d0d07c4":"cffe571a","chunk-2d0d7298":"27a88ee6","chunk-2d0e2c5a":"46f7120f","chunk-2d217def":"9b86ebe8","chunk-2d21a7f3":"603f66cd","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"b8e77524","chunk-2d2259d5":"26f4a39c","chunk-2d22895d":"060c8c65","chunk-2d23721e":"f4233577","chunk-2d5c22d8":"8e9b140f","chunk-34164f06":"0b2abfcf","chunk-3b80800a":"5bcaa5a8","chunk-45b6116d":"7482d4e0","chunk-47d91841":"b5034b11","chunk-525c56ae":"e603b3b4","chunk-5308612d":"9437ac1f","chunk-579497dc":"631049c4","chunk-60350a19":"80a72457","chunk-657610ea":"530191f2","chunk-66c21a65":"2085a38a","chunk-7aa6d045":"04c2204b","chunk-902ca6b4":"703d198e","chunk-9b5d7524":"bf9626ec","chunk-24d10083":"7dc58687","chunk-bcc0d174":"52286f68","chunk-c54d2966":"e3683cd9","chunk-e541af76":"40bc29ee","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-033c7ecc":1,"chunk-0bc784a4":1,"chunk-0c4f239d":1,"chunk-12bf4dfb":1,"chunk-15438fe4":1,"chunk-170c2e37":1,"chunk-1d0ed6ee":1,"chunk-1d2fdd37":1,"chunk-218898d8":1,"chunk-52da3b00":1,"chunk-5966f576":1,"chunk-316ae1f0":1,"chunk-62cba3dc":1,"chunk-245cf861":1,"chunk-2d5c22d8":1,"chunk-34164f06":1,"chunk-3b80800a":1,"chunk-47d91841":1,"chunk-525c56ae":1,"chunk-5308612d":1,"chunk-579497dc":1,"chunk-60350a19":1,"chunk-657610ea":1,"chunk-66c21a65":1,"chunk-7aa6d045":1,"chunk-902ca6b4":1,"chunk-9b5d7524":1,"chunk-24d10083":1,"chunk-bcc0d174":1,"chunk-c54d2966":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-033c7ecc":"1d4a1e4c","chunk-0bc784a4":"b800ec7a","chunk-0c4f239d":"fabe2cbd","chunk-1179b6b8":"31d6cfe0","chunk-12bf4dfb":"3cdf4586","chunk-15438fe4":"372af63c","chunk-170c2e37":"6c54289a","chunk-1d0ed6ee":"5415f63b","chunk-1d2fdd37":"ceea83b6","chunk-1e6a62ff":"31d6cfe0","chunk-1e6b03db":"31d6cfe0","chunk-1e6b05c0":"31d6cfe0","chunk-1e6b3357":"31d6cfe0","chunk-1e6b97da":"31d6cfe0","chunk-1e6c0d5f":"31d6cfe0","chunk-1e7f3edf":"31d6cfe0","chunk-1e7fb51d":"31d6cfe0","chunk-1e802e52":"31d6cfe0","chunk-1e8034ec":"31d6cfe0","chunk-1e806324":"31d6cfe0","chunk-218898d8":"1388ebb7","chunk-52da3b00":"e54d9554","chunk-1e68f8bd":"31d6cfe0","chunk-1e6a5f32":"31d6cfe0","chunk-1e8017f1":"31d6cfe0","chunk-5966f576":"d361b8b6","chunk-b172f240":"31d6cfe0","chunk-316ae1f0":"74015c1d","chunk-62cba3dc":"3a2bf44c","chunk-245cf861":"fabe2cbd","chunk-2d0ac931":"31d6cfe0","chunk-2d0bd20a":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0c5583":"31d6cfe0","chunk-2d0c8234":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0cfa15":"31d6cfe0","chunk-2d0d07c4":"31d6cfe0","chunk-2d0d7298":"31d6cfe0","chunk-2d0e2c5a":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a7f3":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d2259d5":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-2d5c22d8":"72b77847","chunk-34164f06":"bae097e9","chunk-3b80800a":"b800ec7a","chunk-45b6116d":"31d6cfe0","chunk-47d91841":"03a3d60f","chunk-525c56ae":"226bd62c","chunk-5308612d":"18fddd41","chunk-579497dc":"d3e4894e","chunk-60350a19":"38638555","chunk-657610ea":"18fddd41","chunk-66c21a65":"63edfad2","chunk-7aa6d045":"7207b244","chunk-902ca6b4":"d3e4894e","chunk-9b5d7524":"a0c2e9d9","chunk-24d10083":"9caeeec0","chunk-bcc0d174":"de1a8457","chunk-c54d2966":"76714259","chunk-e541af76":"31d6cfe0","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
